import Vue from "vue";
// Components that are registered globaly.
import Language from "./Language.vue";
import PlaceAutocompleteNearStore from "./autocomplete/PlaceAutocompleteNearStore.vue";
import PlaceAutocompleteInput from "./autocomplete/PlaceAutocompleteInput.vue";
import TimeLeft from "./times/TimeLeft.vue";
import TimeLeftCounter from "./times/TimeLeftCounter.vue";
import ExtraTimeOrder from "./times/ExtraTimeOrder.vue";
import ModalAuthForm from "./auth/ModalAuthForm.vue";
import MenuHeaderPublic from "./menu-headers/MenuHeaderPublic.vue";
import MenuStores from "./menu-headers/MenuStores.vue";
import CardModal from "./modal/CardModal.vue";
import CardOrders from "./cards/CardOrders.vue";
import CardEmptyList from "./cards/CardEmptyList.vue";
import CardTemplate from "./CardTemplate.vue";
import CardDefault from "./cards/CardDefault.vue";
import DatatableSearch from "./datatables/DatatableSearch.vue";
import Logo from "./Logo.vue";
import ButtonSuccess from "./buttons/ButtonSuccess.vue";
import ButtonCancel from "./buttons/ButtonCancel.vue";
import ButtonOther from "./buttons/ButtonOther.vue";
import DatePickerRange from "./datepicker/DatePickerRange.vue";
import DatePickerRangeOptions from "./datepicker/DatePickerRangeOptions.vue";
import AppServicesAutocomplete from "./autocomplete/AppServicesAutocomplete.vue";
import AppPaymentTypesAutocomplete from "./autocomplete/AppPaymentTypesAutocomplete.vue";
import AppOrderTypesAutocomplete from "./autocomplete/AppOrderTypesAutocomplete.vue";
import AppUserTypesAutocomplete from "./autocomplete/AppUserTypesAutocomplete.vue";
import AppOrderStatusAutocomplete from "./autocomplete/AppOrderStatusAutocomplete.vue";
import ExcelExport from "./exports/ExcelExport.vue";
import NewUpdates from "./notifications/NewUpdates.vue";
import IntercomCustomers from "./intercom/IntercomCustomers.vue";
import InputColorHex from "./inputs/InputColorHex.vue";
import SelectReasonsRefund from "./selects/SelectReasonsRefund.vue";
import SpinnerLoader from "./SpinnerLoader.vue";
import ProfileCustomer from "./ProfileCustomer.vue";
import CreditCardComponent from "./cards/CreditCardComponent.vue";
import CardItemsComponents from "./cards/CardItemsComponents.vue";
import CardItemsExpandComponents from "./cards/CardItemsExpandComponents.vue";

[
  Language,
  PlaceAutocompleteNearStore,
  PlaceAutocompleteInput,
  TimeLeft,
  TimeLeftCounter,
  ExtraTimeOrder,
  ModalAuthForm,
  MenuHeaderPublic,
  MenuStores,
  CardModal,
  CardTemplate,
  CardDefault,
  CardOrders,
  CardEmptyList,
  DatatableSearch,
  Logo,
  ButtonSuccess,
  ButtonCancel,
  ButtonOther,
  DatePickerRange,
  DatePickerRangeOptions,
  AppServicesAutocomplete,
  AppPaymentTypesAutocomplete,
  AppOrderTypesAutocomplete,
  AppUserTypesAutocomplete,
  AppOrderStatusAutocomplete,
  ExcelExport,
  NewUpdates,
  IntercomCustomers,
  InputColorHex,
  SelectReasonsRefund,
  SpinnerLoader,
  ProfileCustomer,
  CreditCardComponent,
  CardItemsComponents,
  CardItemsExpandComponents,
].forEach((Component) => {
  Vue.component(Component.name, Component);
});
